export const COOKIES_CONSENT_KEY = 'cookies'
